'use client';

import { useTranslations } from 'next-intl';

import CloseIcon from '@/fo/icons/base/icons/cross32.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { styles } from './Banner.styles';

export interface BannerProps {
  onAcceptAll: () => void;
  onConfigure: () => void;
  onDismiss: () => void;
  onClose: () => void;
}

export function Banner({
  onAcceptAll,
  onConfigure,
  onDismiss,
  onClose
}: BannerProps) {
  const slots = styles();
  const t = useTranslations('cookieConsent');
  const isDesktop = useMediaQuery('sm');

  const content = (
    <>
      <button
        type="button"
        className={slots.skip()}
        aria-label={t('close')}
        onClick={onDismiss}
      >
        <CloseIcon className={slots.skipIcon()} />
      </button>
      <p className={slots.title()}>{t('title')}</p>
      <p className={slots.description()}>
        {t.rich('description', {
          link: (chunks) => (
            <a
              href="/legal/politika-cookie/"
              target="_blank"
              rel="noreferrer"
              className={slots.link()}
            >
              {chunks}
            </a>
          )
        })}
      </p>
      <div className={slots.buttons()}>
        <UiKitButtonBase
          color="secondary"
          className={slots.button()}
          onClick={onConfigure}
        >
          {t('configure')}
        </UiKitButtonBase>
        <UiKitButtonBase
          className={slots.button()}
          onClick={onAcceptAll}
        >
          {t('acceptAll')}
        </UiKitButtonBase>
      </div>
    </>
  );

  if (isDesktop) {
    return (
      <div className={slots.base()}>
        <div className={slots.card()}>{content}</div>
      </div>
    );
  }

  return (
    <UiKitDrawerBase
      open
      title={t('title')}
      direction="bottom"
      contentClassName={slots.drawerContent()}
      onOpenChange={(value) => !value && onClose()}
    >
      {content}
    </UiKitDrawerBase>
  );
}
